import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import Source from '@antv/l7-source';
import ImageLayer from "../../image";
import TileFactory from "./base";

var RasterTile = /*#__PURE__*/function (_TileFactory) {
  _inherits(RasterTile, _TileFactory);

  var _super = _createSuper(RasterTile);

  function RasterTile(option) {
    var _this;

    _classCallCheck(this, RasterTile);

    _this = _super.call(this, option);
    _this.parentLayer = option.parent;
    return _this;
  }

  _createClass(RasterTile, [{
    key: "createTile",
    value: function createTile(tile, initOptions) {
      var source = new Source(tile.data, {
        parser: {
          type: 'image',
          extent: tile.bounds
        }
      });
      var layer = this.createLayer({
        L7Layer: ImageLayer,
        tile: tile,
        initOptions: initOptions,
        source: source
      });
      return {
        layers: [layer],
        layerIDList: [layer.id]
      };
    }
  }]);

  return RasterTile;
}(TileFactory);

export { RasterTile as default };